import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';

// Where to land after auth: the in-app path the nav carried in, or Home.
// In-app only — a `from` that does not start with a single '/' could send a
// fresh session to another origin, which is the one thing a return-path
// parameter must never do.
export function safeFrom(search) {
  const from = new URLSearchParams(search).get('from');
  return from && from.startsWith('/') && !from.startsWith('//') ? from : '/';
}

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const { search } = useLocation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await login(username, password);
      navigate(safeFrom(search));
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div style={{ maxWidth: '400px', margin: '80px auto', padding: '0 20px' }}>
      <h1>Worldview</h1>
      <h2>Log in</h2>
      {error && <div style={{ color: 'var(--wv-neg)', marginBottom: '12px' }}>{error}</div>}
      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: '12px' }}>
          <label style={{ display: 'block', marginBottom: '4px' }}>Username</label>
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            style={{ width: '100%', padding: '8px', boxSizing: 'border-box' }}
            autoFocus
            autoComplete="username"
          />
        </div>
        <div style={{ marginBottom: '16px' }}>
          <label style={{ display: 'block', marginBottom: '4px' }}>Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={{ width: '100%', padding: '8px', boxSizing: 'border-box' }}
            autoComplete="current-password"
          />
        </div>
        <button type="submit" disabled={!username || !password || submitting} style={{ width: '100%', padding: '10px' }}>
          {submitting ? 'Logging in...' : 'Log in'}
        </button>
      </form>
      <p style={{ marginTop: '16px', fontSize: '14px' }}>
        No account? <Link to={`/register${search}`}>Register</Link>
      </p>
    </div>
  );
}

export default Login;
